export default class {
  inputClose () {
    if (this.time) {
      this.$emit('update:time', undefined)
    }
  }
}